import MercurioImg from '../images/Mercurio.png';
import VenusImg from '../images/Venus.png';
import TerraImg from '../images/Terra.png';
import MarteImg from '../images/Marte.png';
import JupiterImg from '../images/Jupiter.png';
import SaturnoImg from '../images/Saturno.png';
import Uranoimg from '../images/Urano.png';
import Netunoimg from '../images/Netuno.png';

const Planets = [
  { name: 'Mercúrio', image: MercurioImg, tamanho: 20.879, link: 'https://pt.wikipedia.org/wiki/Merc%C3%BArio_(planeta)'},
  { name: 'Vênus', image: VenusImg, tamanho: 39.104, link: 'https://pt.wikipedia.org/wiki/V%C3%A9nus_(planeta)' },
  { name: 'Terra', image: TerraImg, tamanho: 40.742, link: 'https://pt.wikipedia.org/wiki/Terra' },
  { name: 'Marte', image: MarteImg, tamanho: 30.779, link: 'https://pt.wikipedia.org/wiki/Marte_(planeta)' },
  { name: 'Júpiter', image: JupiterImg, tamanho: 109.820, link: 'https://pt.wikipedia.org/wiki/J%C3%BApiter_(planeta)' },
  { name: 'Saturno', image: SaturnoImg, tamanho: 89.460, link: 'https://pt.wikipedia.org/wiki/Saturno_(planeta)' },
  { name: 'Urano', image: Uranoimg, tamanho: 50.724, link: 'https://pt.wikipedia.org/wiki/Saturno_(planeta)' },
  { name: 'Netuno', image: Netunoimg, tamanho: 49.244, link: 'https://pt.wikipedia.org/wiki/Netuno_(planeta)' },
];

export default Planets;
